import { component as defineComponent } from 'flightjs';
import withButtonStates from 'entry/mixins/with-button-states';

var contestItemSelections = function () {
    this.attributes({
        placeholderSrc: 'data-placeholder-src',
        selectedItemId: '[data-selection-id]',
        selected: '[data-selected]',
        count: '[data-selected-items-count]',
        confirmSelectionButton: '[data-confirm-selection-button]',

        removeSelectionButton: '[data-remove-selection-button]',
        selectedItemThumbnail: '[data-selection-thumbnail]',
        selectedItemName: '[data-selection-name]',

        uiRemoveItemEvent: '',
        uiAddItemEvent: '',
        dataFailedToAddItemEvent: '',
        dataItemsLoadedEvent: '',
        confirmSelectionEvent: '',
    });

    this.after('initialize', function () {
        this.on('click', {
            removeSelectionButton: this.triggerRemove,
            confirmSelectionButton: this.triggerConfirm,
        });

        this.on(document, this.attr.dataFailedToAddItemEvent, this.removeSelectedItem);
        this.on(document, this.attr.dataItemsLoadedEvent, this.refreshItems);

        this.on(document, 'uiItemSelected', this.addSelectedItem);
        this.on(document, 'uiItemUnselected', this.removeSelectedItem);

        this.on(document, 'dataSelectableItemClicked', this.updateSelectedItems);
    });

    this.findItem = function (id) {
        return this.$node.find('[data-selection-id="' + id + '"]');
    };

    this.hasIconPlaceholder = function () {
        return typeof this.$node.attr('data-selection-panel-use-placeholder-icons') !== 'undefined';
    };

    this.isItemSelected = function (id) {
        var item = this.findItem(id);
        return item.length > 0;
    };

    this.tidyItemsAfterRemoval = function () {
        var lastSelected = this.$node.find(this.attr.selected).last().parent();
        var firstNotSelected = this.select('selectedItemId')
            .not(this.attr.selected)
            .first()
            .parent();

        if (firstNotSelected && lastSelected) {
            lastSelected.after(firstNotSelected);
        }
    };

    this.addSelectedItem = function (e, data) {
        var unselectedItems = this.select('selectedItemId').not(this.attr.selected);
        var item = unselectedItems.first();

        item.removeAttr('data-icon-placeholder');
        item.attr('data-selected', true);
        item.attr('data-selection-id', data.id);

        item.find(this.attr.selectedItemThumbnail).attr('src', data.thumbnail);

        item.find(this.attr.selectedItemName).attr('href', data.labelLink).text(data.label);

        this.updateSelectedItems();
    };

    this.getSelectedItemIds = function () {
        var selectedItems = this.select('selectedItemId').filter(this.attr.selected).toArray();

        return selectedItems.map(function (item) {
            return { id: item.getAttribute('data-selection-id') };
        });
    };

    this.updateSelectedItems = function () {
        this.trigger('uiSelectionsUpdated', {
            selectedItems: this.getSelectedItemIds(),
        });
    };

    this.removeSelectedItem = function (e, data) {
        var item = this.findItem(data.id);

        if (item.length) {
            item.removeAttr('data-selected');
            item.attr('data-selection-id', '');

            if (this.hasIconPlaceholder()) {
                item.attr('data-icon-placeholder', true);
            }

            item.find(this.attr.selectedItemThumbnail).attr(
                'src',
                item.attr(this.attr.placeholderSrc)
            );

            item.find(this.attr.selectedItemName).attr('href', '').text('');

            this.tidyItemsAfterRemoval();
        }

        this.updateSelectedItems();
    };

    this.refreshItems = function (e, data) {
        // Remove all selected items
        this.select('selected').each(
            function (idx, item) {
                this.removeSelectedItem(e, {
                    id: $(item).attr('data-selection-id'),
                });
            }.bind(this)
        );

        // Add the items
        data.selectedItems.forEach(function (item) {
            this.addSelectedItem(e, item);
        }, this);
    };

    this.triggerRemove = function (e) {
        var item = $(e.target).closest(this.attr.selectedItemId);
        var designerId = parseInt(item.attr('data-selection-id'), 10);

        if (designerId) {
            this.trigger(item, 'uiItemUnselected', { id: designerId });
            this.trigger(item, this.attr.uiRemoveItemEvent, { id: designerId });
        }
    };

    this.triggerConfirm = function (e) {
        if (this.select('confirmSelectionButton').data('disabled')) {
            e.stopPropagation();
            e.preventDefault();
        } else {
            this.trigger(this.attr.confirmSelectionEvent, {
                selectedItems: this.getSelectedItemIds(),
            });
        }
    };

    this.updateCount = function (e) {
        this.select('count').text(this.select('selected').length);
    };

    this.updateConfirmButton = function (e) {
        if (this.select('selected').length === 0) {
            this.disableButton('confirmSelectionButton');
        } else {
            this.enableButton('confirmSelectionButton');
        }
    };

    this.around('addSelectedItem', function (func, e, data) {
        if (!this.isItemSelected(data.id)) {
            func(e, data);
        }
    });

    this.after('addSelectedItem', this.updateConfirmButton);
    this.after('addSelectedItem', this.updateCount);

    this.after('removeSelectedItem', this.updateConfirmButton);
    this.after('removeSelectedItem', this.updateCount);
};

export default defineComponent(contestItemSelections, withButtonStates);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-item-selections.js